import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import InwardStock from "@/pages/InwardStock";
import OutwardStock from "@/pages/OutwardStock";
import StockInHand from "@/pages/StockInHand";
import Vendors from "@/pages/Vendors";
import Customers from "@/pages/Customers";
import Settings from "@/pages/Settings";
import Reports from "@/pages/Reports";
import PurchaseOrders from "@/pages/PurchaseOrders";
import SalesOrders from "@/pages/SalesOrders";
import Locations from "@/pages/Locations";
import StockTransfers from "@/pages/StockTransfers";
import Production from "@/pages/Production";
import PendingApproval from "@/pages/PendingApproval";
import Layout from "@/components/Layout";

function Protected({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="w-10 h-10 border-2 border-[#16A34A] border-t-transparent animate-spin rounded-full" />
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  if (user.status !== "approved") return <PendingApproval />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/inward" element={<InwardStock />} />
        <Route path="/outward" element={<OutwardStock />} />
        <Route path="/stock" element={<StockInHand />} />
        <Route path="/transfers" element={<StockTransfers />} />
        <Route path="/production" element={<Production />} />
        <Route path="/vendors" element={<Vendors />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/purchase-orders" element={<PurchaseOrders />} />
        <Route path="/sales-orders" element={<SalesOrders />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/locations" element={<Protected adminOnly><Locations /></Protected>} />
        <Route path="/settings" element={<Protected adminOnly><Settings /></Protected>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
